import { IImages, ISkill } from "./mechanics/characters/Character"
// elfs img
import face1 from "./assets/img/characters_icons/elfs/face1.png"
import face1Webp from "./assets/img/characters_icons/elfs/face1.webp"
import face2 from "./assets/img/characters_icons/elfs/face2.png"
import face2Webp from "./assets/img/characters_icons/elfs/face2.webp"
import face3 from "./assets/img/characters_icons/elfs/face3.png"
import face3Webp from "./assets/img/characters_icons/elfs/face3.webp"
// elfs fullFace img
import fullFace1 from './assets/img/characters_img/elfs/full_face1.png'
import fullFace1Webp from './assets/img/characters_img/elfs/full_face1.webp'
import fullFace2 from './assets/img/characters_img/elfs/full_face2.png'
import fullFace2Webp from './assets/img/characters_img/elfs/full_face2.webp'
import fullFace3 from './assets/img/characters_img/elfs/full_face3.png'
import fullFace3Webp from './assets/img/characters_img/elfs/full_face3.webp'
import fullFace4 from './assets/img/characters_img/elfs/full_face4.png'
import fullFace4Webp from './assets/img/characters_img/elfs/full_face4.webp'
// halfling img
import iconHalfling2 from "./assets/img/characters_icons/halfflings/Character1_face1.png"
import iconHalfling2Webp from "./assets/img/characters_icons/halfflings/Character1_face1.webp"
import iconHalfling1 from "./assets/img/characters_icons/halfflings/Character2_face1.png"
import iconHalfling1Webp from "./assets/img/characters_icons/halfflings/Character2_face1.webp"
import iconHalfling3 from "./assets/img/characters_icons/halfflings/Character8_face1.png"
import iconHalfling3Webp from "./assets/img/characters_icons/halfflings/Character8_face1.webp"
// halfling fullFace img
import fullHalffling2 from "./assets/img/characters_img/hulflings/Character1_face1.png"
import fullHalffling2Webp from "./assets/img/characters_img/hulflings/Character1_face1.webp"
import fullHalffling1 from "./assets/img/characters_img/hulflings/Character2_face1.png"
import fullHalffling1Webp from "./assets/img/characters_img/hulflings/Character2_face1.webp"
import fullHalffling3 from "./assets/img/characters_img/hulflings/Character8_face1.png"
import fullHalffling3Webp from "./assets/img/characters_img/hulflings/Character8_face1.webp"
// demons img
import iconDemon1 from "./assets/img/characters_icons/demons/Character2_face1.png"
import iconDemon1Webp from "./assets/img/characters_icons/demons/Character2_face1.webp"
import iconDemon2 from "./assets/img/characters_icons/demons/Character3_face1.png"
import iconDemon2Webp from "./assets/img/characters_icons/demons/Character3_face1.webp"
import iconDemon3 from "./assets/img/characters_icons/demons/Character4_face1.png"
import iconDemon3Webp from "./assets/img/characters_icons/demons/Character4_face1.webp"
// demons fullFace img
import fullDemons1 from "./assets/img/characters_img/demons/Character2_face1.png"
import fullDemons1Webp from "./assets/img/characters_img/demons/Character2_face1.webp"
import fullDemons2 from "./assets/img/characters_img/demons/Character3_face1.png"
import fullDemons2Webp from "./assets/img/characters_img/demons/Character3_face1.webp"
import fullDemons3 from "./assets/img/characters_img/demons/Character4_face1.png"
import fullDemons3Webp from "./assets/img/characters_img/demons/Character4_face1.webp"
// boss fullFace img
import firstBoss from "./assets/img/characters_img/demons/Character5_face1.png"
import firstBossWebp from "./assets/img/characters_img/demons/Character5_face1.webp"
// rogue skills img
import atk from './assets/img/skills/atk.png'
import atkWebp from './assets/img/skills/atk.webp'
import atk2 from './assets/img/skills/Icon10.png'
import atk2Webp from './assets/img/skills/Icon10.webp'
import atk3 from './assets/img/skills/Icon11.png'
import atk3Webp from './assets/img/skills/Icon11.webp'
import atk4 from './assets/img/skills/Icon12.png'
import atk4Webp from './assets/img/skills/Icon12.webp'
// warrior skills img
import warriorSkill from "./assets/img/skills/active1.png"
import warriorSkillWebp from "./assets/img/skills/active1.webp"
import warriorSkillTwo from "./assets/img/skills/active2.png"
import warriorSkillTwoWebp from "./assets/img/skills/active2.webp"
import warriorSkillThree from "./assets/img/skills/active3.png"
import warriorSkillThreeWebp from "./assets/img/skills/active3.webp"
import warriorSkillFour from "./assets/img/skills/active4.png"
import warriorSkillFourWebp from "./assets/img/skills/active4.webp"
// mage skills img
import mageSkill from "./assets/img/skills/1.png"
import mageSkillWebp from "./assets/img/skills/1.webp"
import mageSkillTwo from "./assets/img/skills/2.png"
import mageSkillTwoWebp from "./assets/img/skills/2.webp"
import mageSkillThree from "./assets/img/skills/3.png"
import mageSkillThreeWebp from "./assets/img/skills/3.webp"
import mageSkillFour from "./assets/img/skills/4.png"
import mageSkillFourWebp from "./assets/img/skills/4.webp"
// background img
import { Ibackground } from "./mechanics/location/Location"
import background from "./assets/img/main_bg.png"
import backgroundWebp from "./assets/img/main_bg.webp"
import desert from "./assets/img/desert.png"
import desertWebp from "./assets/img/desert.webp"
import dungeon from "./assets/img/dungeon.jpg"
import dungeonWebp from "./assets/img/dungeon.webp"
// background camp item
import alliesBg from './assets/img/camp/allies_bg.png';
import alliesBgWebp from './assets/img/camp/allies_bg.webp';
import characterBg from './assets/img/camp/character_bg.png';
import characterBgWebp from './assets/img/camp/character_bg.webp';
import equpmentBg from './assets/img/camp/equpment_bg.png';
import equpmentBgWebp from './assets/img/camp/equpment_bg.webp';
// ally
import { Ally, IinitAlly } from "./mechanics/ally/Ally"
import necrah from './assets/img/camp/allies_list/Necrah_Blakahi_hp.png'
import necrahWebp from './assets/img/camp/allies_list/Necrah_Blakahi_hp.webp'
import necrahIcon from './assets/img/camp/allies_list/Necrah_Blakahi_icon.png'
import necrahIconWebp from './assets/img/camp/allies_list/Necrah_Blakahi_icon.webp'
import angin from './assets/img/camp/allies_list/Angin_Applemoon_int.png'
import anginWebp from './assets/img/camp/allies_list/Angin_Applemoon_int.webp'
import anginIcon from './assets/img/camp/allies_list/Angin_Applemoon_icon.png'
import anginIconWebp from './assets/img/camp/allies_list/Angin_Applemoon_icon.webp'
import barunali from './assets/img/camp/allies_list/Barunali_Toldeth_str.png'
import barunaliWebp from './assets/img/camp/allies_list/Barunali_Toldeth_str.webp'
import barunaliIcon from './assets/img/camp/allies_list/Barunali_Toldeth_icon.png'
import barunaliIconWebp from './assets/img/camp/allies_list/Barunali_Toldeth_icon.webp'
import icikra from './assets/img/camp/allies_list/Icikra_Crurud_def.png'
import icikraWebp from './assets/img/camp/allies_list/Icikra_Crurud_def.webp'
import icikraIcon from './assets/img/camp/allies_list/Icikra_Crurud_icon.png'
import icikraIconWebp from './assets/img/camp/allies_list/Icikra_Crurud_icon.webp'
import sanzin from './assets/img/camp/allies_list/Sanzin_Rosewood_con.png'
import sanzinWebp from './assets/img/camp/allies_list/Sanzin_Rosewood_con.webp'
import sanzinIcon from './assets/img/camp/allies_list/Sanzin_Rosewood_icon.png'
import sanzinIconWebp from './assets/img/camp/allies_list/Sanzin_Rosewood_icon.webp'
import tarker from './assets/img/camp/allies_list/Tarker_dex.png'
import tarkerWebp from './assets/img/camp/allies_list/Tarker_dex.webp'
import tarkerIcon from './assets/img/camp/allies_list/Tarker_icon.png'
import tarkerIconWebp from './assets/img/camp/allies_list/Tarker_icon.webp'
// currensy
import bones from './assets/img/bones.png'
import bonesWebp from './assets/img/bones.webp'
import { ICurrensies } from "./mechanics/inventory/Inventory"
// explosion
import exp1 from './assets/img/Explosion_1/Explosion_1.png'
import exp2 from './assets/img/Explosion_1/Explosion_2.png'
import exp3 from './assets/img/Explosion_1/Explosion_3.png'
import exp4 from './assets/img/Explosion_1/Explosion_4.png'
import exp5 from './assets/img/Explosion_1/Explosion_5.png'
import exp6 from './assets/img/Explosion_1/Explosion_6.png'
import exp7 from './assets/img/Explosion_1/Explosion_7.png'
import exp8 from './assets/img/Explosion_1/Explosion_8.png'
import exp9 from './assets/img/Explosion_1/Explosion_9.png'
import exp10 from './assets/img/Explosion_1/Explosion_10.png'
// gold icons, bagpack icon, chest icon
import goldIcon from './assets/img/inventory/coin2.png'
import bagPack from './assets/img/inventory/Backpack1.png'
import chest from './assets/img/Chest2.png'
import goldChest from './assets/img/chest.png'

import dialogNpc from '../src/assets/img/characters_img/npc/dialog_main_npc.png'

export const bossArr: IImages[] = [{ webp: firstBossWebp, img: firstBoss }]

export const raceFullArr: IImages[] = [
    { webp: fullFace4Webp, img: fullFace4 },
    { webp: fullFace2Webp, img: fullFace2 },
    { webp: fullFace3Webp, img: fullFace3 },
    { webp: fullFace1Webp, img: fullFace1 }
]

export const skillsImgArr: ISkill[][] = [
    [
        { images: { img: atk, webp: atkWebp }, dis: "deal damage uses his dex" },
        { images: { img: atk2, webp: atk2Webp }, dis: "deal more damage uses his dex" },
        { images: { img: atk3, webp: atk3Webp }, dis: "that's a lot of damage uses his dex" },
        { images: { img: atk4, webp: atk4Webp }, dis: "deal damage uses his dex ignore armor" }
    ],
    [
        { images: { img: mageSkill, webp: mageSkillWebp }, dis: "deal damage uses his int ignore armor" },
        { images: { img: mageSkillTwo, webp: mageSkillTwoWebp }, dis: "deal more damage uses his int ignor armor" },
        { images: { img: mageSkillThree, webp: mageSkillThreeWebp }, dis: "that's a lot of damage uses his int ignore armor" },
        { images: { img: mageSkillFour, webp: mageSkillFourWebp }, dis: "steal some hp uses his int" }
    ],
    [
        { images: { img: warriorSkill, webp: warriorSkillWebp }, dis: "deal damage uses his str" },
        { images: { img: warriorSkillTwo, webp: warriorSkillTwoWebp }, dis: "deal more damage uses his str" },
        { images: { img: warriorSkillThree, webp: warriorSkillThreeWebp }, dis: "that's a lot of damage uses his str" },
        { images: { img: warriorSkillFour, webp: warriorSkillFourWebp }, dis: "deal damage uses his str ignore armor" }
    ]
]

export const backgrounds: Ibackground[] = [
    { img: background, webp: backgroundWebp },
    { img: desert, webp: desertWebp },
    { img: dungeon, webp: dungeonWebp }
]

interface IRace {
    fullImg: IImages,
    iconImg: IImages,
    tip?: string,
    class?: string
}

export interface IStat {
    desc: string,
    name: string,
    basic: number
}

export const halflingsImgs: IRace[] = [
    { fullImg: { webp: fullHalffling3Webp, img: fullHalffling3 }, iconImg: { webp: iconHalfling3Webp, img: iconHalfling3 }, tip: "hulfling", class: "rogue" },
    { fullImg: { webp: fullHalffling2Webp, img: fullHalffling2 }, iconImg: { webp: iconHalfling2Webp, img: iconHalfling2 }, class: "mage" },
    { fullImg: { webp: fullHalffling1Webp, img: fullHalffling1 }, iconImg: { webp: iconHalfling1Webp, img: iconHalfling1 }, class: "warrior" },
]
export const demonsImgs: IRace[] = [
    { fullImg: { webp: fullDemons3Webp, img: fullDemons3 }, iconImg: { webp: iconDemon3Webp, img: iconDemon3 }, tip: "demon", class: "rogue" },
    { fullImg: { webp: fullDemons2Webp, img: fullDemons2 }, iconImg: { webp: iconDemon2Webp, img: iconDemon2 }, class: "mage" },
    { fullImg: { webp: fullDemons1Webp, img: fullDemons1 }, iconImg: { webp: iconDemon1Webp, img: iconDemon1 }, class: "warrior" },
]
export const elfsImgs: IRace[] = [
    { fullImg: { webp: fullFace3Webp, img: fullFace3 }, iconImg: { webp: face3Webp, img: face3 }, tip: "elf", class: "rogue" },
    { fullImg: { webp: fullFace2Webp, img: fullFace2 }, iconImg: { webp: face2Webp, img: face2 }, class: "mage" },
    { fullImg: { webp: fullFace1Webp, img: fullFace1 }, iconImg: { webp: face1Webp, img: face1 }, class: "warrior" },
]

export const raceArr = [elfsImgs[0], halflingsImgs[0], demonsImgs[0]]

export const classArr = [elfsImgs, halflingsImgs, demonsImgs]

export const descrArr = [
    'Nimble combatant focused on stealth and social skills, also capable of high-damage special attacks balanced by sub-par resistance to injury.',
    'Featuring powerful magical abilities, but physically weak.',
    'Focused on combat abilities, but almost entirely lacking in magical abilities',
    'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quibusdam, nam dicta! Tenetur rem aliquid, doloribus magnam temporibus corrupti provident doloremque!'
]

export const statsDescription: IStat[] = [
    { name: "HP", basic: 0, desc: "Your character basic hit points" },
    { name: "Attack", basic: 0, desc: "How good your character hit enemy" },
    { name: "CON", basic: 10, desc: "How many hit points your character get" },
    { name: "DEX", basic: 10, desc: "Your character additional armor" },
    { name: "STR", basic: 10, desc: "Your character physical damage" },
    { name: "CHR", basic: 10, desc: "How good your character speaks" },
    { name: "WIS", basic: 10, desc: "Your character magic ressist" },
    { name: "INT", basic: 10, desc: "Your character magic damage" }
]
// Camp items 
export interface ICampItem {
    id: string
    images: IImages
    title: string
}

export const campItemsArr: ICampItem[] = [
    { id: 'allies', images: { img: alliesBg, webp: alliesBgWebp }, title: 'Allies' },
    { id: 'character', images: { img: characterBg, webp: characterBgWebp }, title: 'Character upgrade' },
    { id: 'equipment', images: { img: equpmentBg, webp: equpmentBgWebp }, title: 'Equpment upgrade' }
]
// Allies 
export const necrahInitParams: IinitAlly = {
    initId: 'necrah',
    initImg: { webp: necrahWebp, img: necrah },
    initIcon: { webp: necrahIconWebp, img: necrahIcon },
    initName: 'Necrah Blakahi',
    initProfession: 'Shaman'
}

export const anginInitParams: IinitAlly = {
    initId: 'angin',
    initImg: { webp: anginWebp, img: angin },
    initIcon: { webp: anginIconWebp, img: anginIcon },
    initName: 'Angin Applemoon',
    initProfession: 'Wizard'
}

export const barunaliInitParams: IinitAlly = {
    initId: 'barunali',
    initImg: { webp: barunaliWebp, img: barunali },
    initIcon: { webp: barunaliIconWebp, img: barunaliIcon },
    initName: 'Barunali Toldeth',
    initProfession: 'Wrestler'
}

export const icikraInitParams: IinitAlly = {
    initId: 'icikra',
    initImg: { webp: icikraWebp, img: icikra },
    initIcon: { webp: icikraIconWebp, img: icikraIcon },
    initName: 'Icikra Crurud',
    initProfession: 'Bodyguard'
}

export const sanzinInitParams: IinitAlly = {
    initId: 'sanzin',
    initImg: { webp: sanzinWebp, img: sanzin },
    initIcon: { webp: sanzinIconWebp, img: sanzinIcon },
    initName: 'Sanzin Rosewood',
    initProfession: 'Survival master'
}

export const tarkerInitParams: IinitAlly = {
    initId: 'tarker',
    initImg: { webp: tarkerWebp, img: tarker },
    initIcon: { webp: tarkerIconWebp, img: tarkerIcon },
    initName: 'Tarker',
    initProfession: 'Dodger'
}

// Currensy
export const testCurrensy: ICurrensies = {
    'bones': {
        name: 'bones',
        amount: 100,
        images: { webp: bonesWebp, img: bones }
    }
}

// explosion
// export const particles = [exp1, exp2, exp3, exp4, exp5, exp6, exp7, exp8, exp9, exp10]
export const particles = [exp2, exp3, exp4]